import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { type AssignMemberToInboxStore } from 'pages/settings/pages/members/ui/AssignMemberToInbox/store/assignMemberToInboxStore'
import styles from './styles.module.scss'

type IAssignMemberActionsProps = {
  store: AssignMemberToInboxStore
  onAction: () => void
  disabled?: boolean
  loading?: boolean
  onBackOverride?: () => void
}

export const AssignMemberActions = observer(
  ({ store, onAction, disabled, loading, onBackOverride }: IAssignMemberActionsProps) => {
    const {
      isReviewMode,
      onReject,
      isNewInboxType,
      isFirstStep,
      isLastStep,
      assignNewInboxStore: { decreaseStep },
    } = store

    const showBackButton = isNewInboxType && !isFirstStep
    const showRejectButton = !isNewInboxType && isReviewMode

    const getActionButtonText = () => {
      if (!isLastStep) return 'Next'
      return isReviewMode ? 'Approve' : 'Assign'
    }

    const handleBack = () => {
      onBackOverride?.()
      decreaseStep()
    }

    const renderBackButton = () => {
      if (!showBackButton) return null

      return (
        <Button
          text='Back'
          contained='secondary'
          onClick={handleBack}
          fullWidth
          className={styles.actionButton}
        />
      )
    }

    const renderRejectButton = () => {
      if (!showRejectButton || !onReject) return null

      return (
        <Button
          text='Reject'
          contained='secondary'
          intent='destructive'
          fullWidth
          onClick={onReject}
          className={styles.actionButton}
          disabled={loading}
        />
      )
    }

    const renderActionButton = () => {
      return (
        <Button
          text={getActionButtonText()}
          contained='primary'
          fullWidth
          onClick={onAction}
          className={styles.actionButton}
          disabled={disabled}
          loading={loading}
        />
      )
    }

    return (
      <div className={styles.container}>
        {renderBackButton()}
        {renderRejectButton()}
        {renderActionButton()}
      </div>
    )
  }
)
